import React from 'react';
import type { IExplainedScoreMaybe } from 'autogen/swagger/all';
import ExplainedScore from './ExplainedScore';

export default function ProductItemDebugger({ explainedScore }: { explainedScore?: IExplainedScoreMaybe }) {
    return <>{explainedScore && <ExplainedScore model={explainedScore} />}</>;
}
